/**
 * FRONT-2382 (feedback round 2) — pure parts of the "zoomed" design
 * suggestion / reference viewer: which index is on screen and the pick
 * button's own label. Kept free of React (same reasoning as
 * `design-direction-gate.ts`) so the wrap-around math and the label choice
 * are testable without mounting the Dialog — this repo's frontend suite
 * runs under plain node with no DOM, so nothing here can be proven by
 * simulating a click on the real arrow buttons.
 */

/**
 * Move the viewer by one step, wrapping at both ends — the lightbox
 * convention: past the last item, "next" returns to the first, and
 * "previous" from the first goes to the last. `length <= 0` is defensive
 * (the viewer never mounts with zero items, since it only renders once an
 * index into a non-empty list is set) and returns 0 rather than dividing by
 * it.
 */
export function stepViewerIndex(current: number, length: number, delta: -1 | 1): number {
  if (length <= 0) return 0;
  return (current + delta + length) % length;
}

/**
 * The viewer's own pick button label — a primary action whose text names
 * its own current state (same convention as the cap gate's visible reason
 * text elsewhere in this feature: never assume the reader remembers what a
 * checkmark meant).
 */
export function viewerPickButtonLabel(picked: boolean): string {
  return picked ? 'Picked — click to unpick' : 'Pick this direction';
}
